import { Page } from '../pages/policy/compliance';

export default function () {
  return (
    <Page />
  );
};
